/**
 * PBS tags every payment method with the billing flows it may be used for.
 * A method with no `allowedPayments` comes from a PBS version that predates
 * the field, so treat it as eligible everywhere rather than hiding a payment
 * method that actually works.
 */
export var isPaymentMethodAllowedForFlow = function (method, flow) { return !method.allowedPayments || method.allowedPayments.includes(flow); };
/**
 * Narrows a fetched payment method list down to the methods PBS allows for a
 * given billing flow. Use this before deciding whether the account already has
 * a usable payment method for a step.
 */
export var filterPaymentMethodsByFlow = function (methods, flow) {
    return (methods || []).filter(function (method) {
        return isPaymentMethodAllowedForFlow(method, flow);
    });
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGF5bWVudE1ldGhvZHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJwYXltZW50TWV0aG9kcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFLQTs7Ozs7R0FLRztBQUNILE1BQU0sQ0FBQyxJQUFNLDZCQUE2QixHQUFHLFVBQzNDLE1BQTZCLEVBQzdCLElBQWlCLElBQ2QsT0FBQSxDQUFDLE1BQU0sQ0FBQyxlQUFlLElBQUksTUFBTSxDQUFDLGVBQWUsQ0FBQyxRQUFRLENBQUMsSUFBSSxDQUFDLEVBQWhFLENBQWdFLENBQUM7QUFFdEU7Ozs7R0FJRztBQUNILE1BQU0sQ0FBQyxJQUFNLDBCQUEwQixHQUFHLFVBQ3hDLE9BQW1ELEVBQ25ELElBQWlCO0lBRWpCLE9BQUEsQ0FBQyxPQUFPLElBQUksRUFBRSxDQUFDLENBQUMsTUFBTSxDQUFDLFVBQUMsTUFBTTtRQUM1QixPQUFBLDZCQUE2QixDQUFDLE1BQU0sRUFBRSxJQUFJLENBQUM7SUFBM0MsQ0FBMkMsQ0FDNUM7QUFGRCxDQUVDLENBQUMifQ==